import { render } from "./LoadingTextChanger.vue?vue&type=template&id=7b1bd6b1&scoped=true&ts=true"
import script from "./LoadingTextChanger.vue?vue&type=script&lang=ts"
export * from "./LoadingTextChanger.vue?vue&type=script&lang=ts"

import "./LoadingTextChanger.vue?vue&type=style&index=0&id=7b1bd6b1&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1bd6b1"]])

export default __exports__